export * from './analytics';
export * from './images';
export * from './socket';

export const NODES_DEPTH = 4;

export const PUSH_PRODUCTS_FROM_DETAIL = 'detail-page-view';
export const PUSH_PRODUCTS_FORM_CART = 'shopping-cart-page-view';
export const PUSH_PRODUCTS_FORM_ADD_TO_CART = 'add-to-cart';

export const DEBOUNCE_DELAY_CART_QUANTITY = 1000;

// Carts
export const CARTS_LIMIT = 10;

// Origin
export const ORIGIN_CART = 'cart';

// Aside
export const ASIDE_ID = 'main-aside';

export const WISHLISTS_TYPES = {
  WISHLIST: 'wishlist',
  DEFAULT_CAT: 'default_cat',
  ORPHAN_LIST: 'orphan_list',
  SECTION: 'section',
  FILE: 'file',
  CATEGORY: 'category',
};

export const WISHLISTS_STYLE = {
  hoverColor: 'var(--grey-primary-transparent)',
  initialColor: 'var(--white-transparent)',
};

export const FILTERS_TYPES = {
  FILTERS: 'filters',
  ADVANCED_FILTER: 'advanced-filters',
};

export const PRODUCT_BARCODE_MARGINS = {
  with: '5mm 5mm 0',
  without: '1mm 1mm 0',
};
export const PRODUCT_BARCODE_SIZES = { SMALL: 'small', BIG: 'big' };
export const PRODUCT_BARCODE_PARAMS = {
  big: {
    fontSize: 20,
    format: 'CODE128',
    height: 60,
    width: 1.5,
  },
  small: {
    fontSize: 12,
    format: 'CODE128',
    height: 35,
    width: 1,
  },
};

// ACCOUNT
export const USER_ADDRESSES_LIMIT = 20;

export const KEY_COMPLETION = {
  gammes: 'gammes',
  brands: 'brands',
};

export const PRINT_PAGE_PARAMS = {
  with_price: 'with-price',
  without_price: 'without-price',
};

export const APP_CRAFTER_GOOGLE_PLAY_LINK = 'https://play.google.com';
export const APP_CRAFTER_APP_STORE_LINK = 'https://apps.apple.com';
